var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticStyle:{"width":"1.4rem"},attrs:{"src":require('@/image/qukuan.png'),"alt":""},on:{"click":_vm.moreEvent}}),(_vm.visible_bold)?_c('tikuan',{attrs:{"island":_vm.visible_bold,"record":_vm.record},on:{"child":_vm.moreEvent}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }